import { tokenAxios } from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";
import { TaoOrderTypesArgs, TaoOrderTypesList } from "@/types/tao-routing";
import { useAppState } from "@/contexts/app-state";
import { buildApiUrl } from "@/utils/api";

const getTaoOrderTypes = async (params: TaoOrderTypesArgs) => {
  // @eslint-disable-line
  const { data } = await tokenAxios().get<TaoOrderTypesList[]>(buildApiUrl("taoOrderTypes"), { params });
  return data;
};

export const useTaoOrderTypes = () => {
  const { context, loggedInUser } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const requestedUser = loggedInUser;

  return useQuery<TaoOrderTypesList[], Error>({
    queryKey: ["Tao-Routing-Order-Types", practiceId, requestedUser],
    queryFn: () => getTaoOrderTypes({ practiceId, requestedUser }),
  });
};
